import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, HostListener } from '@angular/core';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ConnectionService } from '../../service/connection.service';
import { AuthService } from '../../service/auth.service';
import { NotificationsService } from '../../service/notifications.service';
import { environment } from '../../../environments/environment';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.css',
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslatePipe, IconComponent],
})
export class NavBarComponent implements OnInit {
  private translate = inject(TranslateService);
  private connection = inject(ConnectionService);
  private router = inject(Router);
  private auth = inject(AuthService);
  notif = inject(NotificationsService);

  currentLang = this.translate.getCurrentLang() || 'it';
  menuOpen = false;
  accountOpen = false; // menu account avatar (campanella + avatar, desktop+mobile)
  userRole = localStorage.getItem('user_role') ?? '';

  avatarUrl: string | null = null;
  avatarError = false;
  initials = ''; // fallback quando non c'è foto avatar
  userName = ''; // nome per il saluto nel menu account

  // ── NOTIFICHE (stato/dati in NotificationsService, condiviso con la bottom tab bar) ──
  notifOpen = false;

  ngOnInit(): void {
    this.setupAvatar();
  }

  toggleNotif(): void {
    this.notifOpen = !this.notifOpen;
    if (this.notifOpen) this.notif.ensureLoaded();
  }

  markRead(notif: any): void {
    this.notif.markRead(notif, (n) => this.navigateToNotif(n));
  }

  markAllRead(): void {
    this.notif.markAllRead();
  }

  private navigateToNotif(notif: any): void {
    this.notifOpen = false;
    this.notif.navigateToNotif(notif);
  }

  getNotifIcon(type: string): string {
    return this.notif.getNotifIcon(type);
  }

  @HostListener('document:click', ['$event'])
  onDocClick(e: MouseEvent): void {
    const target = e.target as HTMLElement;
    if (!target.closest('.notif-wrapper')) this.notifOpen = false;
    if (!target.closest('.avatar-menu')) this.accountOpen = false;
  }

  toggleAccount(): void {
    this.accountOpen = !this.accountOpen;
  }

  private setupAvatar(): void {
    try {
      const token = localStorage.getItem('token') ?? '';
      const payload = JSON.parse(atob(token.split('.')[1]));
      const id = payload?.sub;
      if (id) this.avatarUrl = `${environment.apiUrl}/auth/avatar/${id}`;
    } catch {
      this.avatarUrl = null;
    }
    this.fetchInitials();
  }

  // Iniziali nome+cognome come fallback quando manca la foto.
  // '@' → niente loader; 'auth/profile' è cacheato (già caricato dal profilo).
  private fetchInitials(): void {
    this.connection.get(
      '@auth/profile',
      (data: any) => {
        const name = data?.user?.name ?? '';
        const lastname = data?.user?.lastname ?? '';
        this.userName = name;
        this.initials = `${name.charAt(0)}${lastname.charAt(0)}`.toUpperCase();
      },
      () => {},
    );
  }

  logout(): void {
    // Revoca la tessera lato server (best-effort), poi pulisci e vai al login.
    this.auth.logout().subscribe(() => {
      localStorage.clear();
      this.router.navigate(['/login']);
    });
  }

  get isAdmin(): boolean {
    return ['admin', 'admin_readonly', 'support', 'stats'].includes(this.userRole);
  }

  changeLang(lang: 'it' | 'en' | 'es'): void {
    this.translate.use(lang);
    this.currentLang = lang;
    localStorage.setItem('lang', lang);
    this.connection.put('@auth/preferences', { preferred_lang: lang }, () => {}, () => {});
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }
  closeMenu(): void {
    this.menuOpen = false;
  }
}
